import { useLazyQuery, useQuery } from '@apollo/client';
import { Flex, Text, Card } from 'rebass/styled-components'
import PleaseWait from '../../components/PleaseWait';
import { GET_PATIENT_QUICKVIEW } from '../../graphql/queries';
import { IProviderGetPatientsQuickviewInput, IProviderGetPatientsQuickviewOutput } from '../../graphql/types/queries/patient';
import { Constants } from '../../utils/Constants';
import { getMockedFirstName, getMockedLastName, getMockedPhone, getMockedStreetAddress, getMockedEmail } from '../../utils/mocks';
import { Insurances } from './Insurances';
import { useEffect, useRef } from 'react';
import { useIsVisible } from '../../hooks/useIsVisible';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';

interface IQuickviewProps {
  id: string
}

export const Quickview: React.FC<IQuickviewProps> = ({ id }) => {

  const ref = useRef<any>();
  const isVisible = useIsVisible(ref);
  const [load, { data, loading, error }] = useLazyQuery<IProviderGetPatientsQuickviewOutput, IProviderGetPatientsQuickviewInput>(GET_PATIENT_QUICKVIEW, {
    variables: {
      id
    }
  })

  useEffect(() => {
    if (!!isVisible) {
      load()
    }
  }, [isVisible])
  // const { data, loading } = useQuery<IProviderGetPatientsQuickviewOutput, IProviderGetPatientsQuickviewInput>(GET_PATIENT_QUICKVIEW,
  //   { variables: { id } })

  // if (!!loading) {
  //   return (
  //     <Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
  //       <PleaseWait
  //         text="Loading Patient's Information" />
  //     </Flex>
  //   )
  // }

  let firstName = data?.getProviderPatientQuickview.firstName
  let lastName = data?.getProviderPatientQuickview.lastName
  let homePhone = data?.getProviderPatientQuickview.homePhone
  let mobilePhone = data?.getProviderPatientQuickview.mobilePhone
  let address1 = data?.getProviderPatientQuickview.address1
  let email = data?.getProviderPatientQuickview.email

  if (Constants.IS_SCRAMBLING_MODE) {
    firstName = getMockedFirstName()
    lastName = getMockedLastName()
    homePhone = getMockedPhone()
    mobilePhone = getMockedPhone()
    address1 = getMockedStreetAddress()
    email = getMockedEmail()
  }

  return (
    <Flex ref={ref} flexDirection={'column'} width='100%' padding={'20px'}>
      {!!loading ? (
        <Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
          <PleaseWait
            text="Loading Patient's Information" />
        </Flex>
      ) : (
        <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', paddingLeft: '20px', borderLeft: '3px solid #FFABA0' }} paddingY={'12px'} mb={4}>
          <Text fontWeight={600} fontSize='18px' mb={3}>Contact</Text>

          <Text ml={2}>{address1}</Text>
          <Text ml={2}>{data?.getProviderPatientQuickview.address2}</Text>
          <Text ml={2}>{data?.getProviderPatientQuickview.city}, {data?.getProviderPatientQuickview.state} {data?.getProviderPatientQuickview.zip}</Text>


          <Text ml={2} mt={3} style={{ cursor: 'pointer' }} onClick={() => {
            window.open(`dialpad://${homePhone?.replace(/[^\d+]/g, '')}?launchMinimode=1&crmLogging=0&showDispositions=1&customData=${encodeURI(`${firstName} ${lastName}` || '')}`);
          }}>Home phone: {formatPhoneNumber(homePhone)}</Text>
          <Text ml={2} style={{ cursor: 'pointer' }} onClick={() => {
            window.open(`dialpad://${mobilePhone?.replace(/[^\d+]/g, '')}?launchMinimode=1&crmLogging=0&showDispositions=1&customData=${encodeURI(`${firstName} ${lastName}` || '')}`);
          }}>Mobile phone: {formatPhoneNumber(mobilePhone)}</Text>

          <Text ml={2} mt={3}>{email}</Text>

        </Flex>
      )}
      <Insurances id={id} />

    </Flex>);
}